import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const Sparkle = (props: SvgProps) => (
  <Svg width={28} height={28} viewBox="0 0 28 28" fill="none" {...props}>
    <g filter="url(#filter0_iin_1097_19450)">
      <path
        d="M13.3039 18.1839L12.3154 20.4479C11.9359 21.3182 10.7314 21.3182 10.351 20.4479L9.36255 18.1839C8.48255 16.1688 6.89944 14.5653 4.92433 13.6888L2.20433 12.4817C1.33944 12.0977 1.33944 10.839 2.20433 10.455L4.83989 9.28526C6.86566 8.38571 8.47722 6.7226 9.34211 4.63993L10.343 2.22749C10.7146 1.33237 11.9519 1.33237 12.3234 2.22749L13.3243 4.63993C14.1892 6.72349 15.8008 8.3866 17.8266 9.28526L20.4621 10.455C21.327 10.839 21.327 12.0977 20.4621 12.4817L17.7412 13.6897C15.767 14.5662 14.183 16.1697 13.3039 18.1839Z"
        fill="url(#paint0_linear_1097_19450)"
      />
      <path
        d="M22.4277 25.3743L22.1263 26.0649C21.9059 26.5707 21.2054 26.5707 20.985 26.0649L20.6837 25.3743C20.1468 24.1432 19.1788 23.1627 17.9717 22.6258L17.0437 22.2134C16.5414 21.9903 16.5414 21.2605 17.0437 21.0374L17.9201 20.6481C19.1583 20.0978 20.1432 19.0809 20.6712 17.8081L20.9805 17.0614C21.1965 16.5414 21.9157 16.5414 22.1308 17.0614L22.4401 17.8081C22.9681 19.0809 23.953 20.0978 25.1912 20.6481L26.0677 21.0374C26.5699 21.2605 26.5699 21.9903 26.0677 22.2134L25.1397 22.6258C23.9325 23.1627 22.9645 24.1432 22.4277 25.3743Z"
        fill="url(#paint1_linear_1097_19450)"
      />
    </g>
    <defs>
      <filter
        id="filter0_iin_1097_19450"
        x="-1.2535"
        y="-0.506585"
        width="30.1332"
        height="29.0667"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1.92" dy="1.22667" />
        <feGaussianBlur stdDeviation="1.06667" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.937255 0 0 0 0 0.0980392 0 0 0 0 0.431373 0 0 0 0.7 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1097_19450"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.54667" dy="-1.17333" />
        <feGaussianBlur stdDeviation="2.912" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.501961 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_1097_19450"
          result="effect2_innerShadow_1097_19450"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="37.5 37.5"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="2877"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="effect2_innerShadow_1097_19450"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood floodColor="rgba(239, 25, 110, 0.5)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect3_noise_1097_19450">
          <feMergeNode in="effect2_innerShadow_1097_19450" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <linearGradient
        id="paint0_linear_1097_19450"
        x1="21.5999"
        y1="9.99994"
        x2="10.1808"
        y2="25.7747"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#274AE2" />
        <stop offset="0.466346" stopColor="#FFEB80" />
        <stop offset="1" stopColor="#EF196E" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1097_19450"
        x1="26.9334"
        y1="21.4667"
        x2="20.652"
        y2="28.6819"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#274AE2" />
        <stop offset="0.466346" stopColor="#FFEB80" />
        <stop offset="1" stopColor="#EF196E" />
      </linearGradient>
    </defs>
  </Svg>
);

export default Sparkle;
